import React, {useContext} from 'react';
import File from 'app/react/components/File'

export default function Files (props) {
  return (
    <>
      {props.files.length > 0 && (
        <div className="dm-image-text__files">
          {props.files.map((file, i) => <File key={i} {...file} />)}
        </div>
      )}
    </>
  )
}